/* lystia-toast.js — тости (T-E2-11, parity/overlays.md §7). Підключення: <script src="{{ 'lystia-toast.js' | asset_url }}" defer> (після lystia-core.js).
   Контейнер: #toasts[aria-live=polite] у layout/theme.liquid. Один тост за раз: новий замінює наявні.
   API: document.lystiaToast.show(text, {icon, action:{label, href|onClick}, duration}) · .dismiss(el)
        або подія document: new CustomEvent('lystia:toast', {detail:{text, icon, action, duration}}).
   Іконки: клонуються з <template id="LystiaToastIcons"> (дочірні елементи з data-icon="check|alert|heart|heart-fill…"); немає шаблону/іконки -> тост без іконки.
   Тексти приходять від викликача (з locales через Liquid), у файлі їх немає. */
(function () {
  'use strict';
  if (document.lystiaToast) return;

  const DEFAULT_MS = 2600; /* тривалість за замовчуванням */
  const RESUME_MS = 1200;  /* після pointerup */
  const OUT_MS = 260;      /* видалення з DOM після .is-out */

  function dismiss(t) {
    if (!t || !t.isConnected || t.classList.contains('is-out')) return;
    t.classList.remove('is-in');
    t.classList.add('is-out');
    setTimeout(() => t.remove(), OUT_MS);
  }

  function iconNode(name) {
    if (!name) return null;
    const tpl = document.getElementById('LystiaToastIcons');
    if (!tpl || !tpl.content) return null;
    const src = tpl.content.querySelector('[data-icon="' + name + '"]');
    if (!src) return null;
    const ico = document.createElement('span');
    ico.className = 'toast__ico';
    Array.prototype.forEach.call(src.childNodes, (n) => ico.appendChild(n.cloneNode(true)));
    return ico;
  }

  function show(text, o) {
    const opts = o || {};
    const host = document.getElementById('toasts') || document.body;
    Array.prototype.slice.call(host.querySelectorAll('.toast')).forEach(dismiss);
    const t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    const ico = iconNode(opts.icon);
    if (ico) t.appendChild(ico);
    const tx = document.createElement('span');
    tx.className = 'toast__text';
    tx.textContent = text == null ? '' : String(text);
    t.appendChild(tx);
    if (opts.action) {
      const a = document.createElement(opts.action.href ? 'a' : 'button');
      a.className = 'toast__act';
      if (opts.action.href) a.setAttribute('href', opts.action.href); else a.setAttribute('type', 'button');
      a.textContent = opts.action.label || '';
      a.addEventListener('click', () => { dismiss(t); if (typeof opts.action.onClick === 'function') opts.action.onClick(); });
      t.appendChild(a);
    }
    host.appendChild(t);
    void t.offsetHeight; /* reflow -> старт transition */
    t.classList.add('is-in');
    const timer = setTimeout(() => dismiss(t), opts.duration || DEFAULT_MS);
    t.addEventListener('pointerdown', () => clearTimeout(timer));
    t.addEventListener('pointerup', () => setTimeout(() => dismiss(t), RESUME_MS));
    return t;
  }

  document.lystiaToast = Object.freeze({ show: show, dismiss: dismiss });
  document.addEventListener('lystia:toast', (e) => {
    const d = e.detail || {};
    show(d.text, d);
  });
})();
